export default "__VITE_ASSET__d12afa5f__"